'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _initCustomNavFlickity = require('../helpers/initCustomNavFlickity');

var _initCustomNavFlickity2 = _interopRequireDefault(_initCustomNavFlickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components

// PDP Slider

document.addEventListener('DOMContentLoaded', function (event) {
  var numberedSliders = document.querySelectorAll('.numbered-slider__container');

  [].concat((0, _toConsumableArray3.default)(numberedSliders)).forEach(function (slider) {
    // Initialize the slider
    var sliderFlickity = (0, _initCustomNavFlickity2.default)(slider, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      adaptiveHeight: true,
      wrapAround: true
    });
  });
}); /*----------------------------
    Scripts
    ----------------------------*/

// Helpers